import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Server-side idle enforcement: any request that comes back 401 because the
// session timed out due to inactivity yanks the user to the login screen with
// a clear reason (covers background polls / other tabs, not just the local
// inactivity timer).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const detail = error?.response?.data?.detail;
    if (
      error?.response?.status === 401 &&
      typeof detail === "string" &&
      detail.toLowerCase().includes("inactivity")
    ) {
      try {
        localStorage.removeItem("tlb_last_activity");
      } catch {
        /* ignore */
      }
      if (!window.location.pathname.startsWith("/login")) {
        window.location.replace("/login?reason=inactivity");
      }
    }
    return Promise.reject(error);
  },
);

